import React from 'react';
import { useWatchlist } from '../useContext/WatchlistContext';

const WatchlistButtons = ({ item, showLabels = false, size = 'default' }) => {
  const { 
    toggleWatchlist, 
    toggleFavorites, 
    isInWatchlist, 
    isInFavorites,
    loading 
  } = useWatchlist();

  const itemType = item.type || (item.title ? 'movie' : 'tv');
  const inWatchlist = isInWatchlist(item.id, itemType);
  const inFavorites = isInFavorites(item.id, itemType);

  const handleWatchlistClick = () => {
    if (!loading) {
      toggleWatchlist(item);
    }
  };

  const handleFavoritesClick = () => {
    if (!loading) {
      toggleFavorites(item);
    }
  };

  const iconSize = size === 'small' ? 'ri-sm' : '';
  const buttonClass = size === 'small' ? 'btn-sm' : '';

  return (
    <div className="watchlist-buttons d-flex align-items-center">
      {/* Watchlist Button */}
      <button
        className={`btn ${buttonClass} ${inWatchlist ? 'btn-warning' : 'btn-outline-light'} me-2`}
        onClick={handleWatchlistClick}
        disabled={loading}
        title={inWatchlist ? 'Remove from Watchlist' : 'Add to Watchlist'}
      >
        <i className={`ri-add-line ${iconSize}`}></i>
        {showLabels && (
          <span className="ms-1">
            {inWatchlist ? 'In Watchlist' : 'Watchlist'}
          </span>
        )}
      </button>

      {/* Favorites Button */}
      <button
        className={`btn ${buttonClass} ${inFavorites ? 'btn-danger' : 'btn-outline-light'}`}
        onClick={handleFavoritesClick}
        disabled={loading}
        title={inFavorites ? 'Remove from Favorites' : 'Add to Favorites'}
      >
        <i className={`ri-heart-fill ${iconSize}`}></i>
        {showLabels && (
          <span className="ms-1">
            {inFavorites ? 'Favorited' : 'Favorite'}
          </span>
        )}
      </button>
    </div>
  );
};

// Compact version for movie/TV cards
export const CompactWatchlistButtons = ({ item }) => {
  const { 
    toggleWatchlist, 
    toggleFavorites, 
    isInWatchlist, 
    isInFavorites,
    loading 
  } = useWatchlist();

  // Debug: Log the item data being passed
  console.log('CompactWatchlistButtons: Received item:', item);

  const itemType = item.type || (item.title ? 'movie' : 'tv');
  const inWatchlist = isInWatchlist(item.id, itemType);
  const inFavorites = isInFavorites(item.id, itemType);

  // Debug: Log the determined values
  console.log('CompactWatchlistButtons: itemType:', itemType, 'inWatchlist:', inWatchlist, 'inFavorites:', inFavorites);

  const handleWatchlistClick = () => {
    if (!loading) {
      console.log('CompactWatchlistButtons: handleWatchlistClick called with item:', item);
      toggleWatchlist(item);
    }
  };

  const handleFavoritesClick = () => {
    if (!loading) {
      console.log('CompactWatchlistButtons: handleFavoritesClick called with item:', item);
      toggleFavorites(item);
    }
  };

  return (
    <ul className="list-inline p-0 m-0 music-play-lists">
      <li>
        <span 
          onClick={handleWatchlistClick}
          style={{ 
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1,
            color: inWatchlist ? '#ffc107' : 'inherit'
          }}
          title={inWatchlist ? 'Remove from Watchlist' : 'Add to Watchlist'}
        >
          <i className="ri-add-line"></i>
        </span>
      </li>
      <li>
        <span 
          onClick={handleFavoritesClick}
          style={{ 
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1,
            color: inFavorites ? '#dc3545' : 'inherit'
          }}
          title={inFavorites ? 'Remove from Favorites' : 'Add to Favorites'}
        >
          <i className="ri-heart-fill"></i>
        </span>
        <span className="count-box">
          {item?.vote_count || item?.vote_average || '0'}
        </span>
      </li>
    </ul>
  );
};

export default WatchlistButtons;
